import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "back",
  "use": "back-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"back\"><defs><style>#back .cls-1{fill:none}</style></defs><title>资源 78</title><g id=\"back_图层_2\" data-name=\"图层 2\"><g id=\"back_图层_1-2\" data-name=\"图层 1\"><g id=\"back_arrowleft\"><path id=\"back_Shape\" d=\"M20 11H6.54l5.07-4.88a1 1 0 0 0-1.43-1.52l-6.9 6.64a1 1 0 0 0 0 1.46l6.94 6.67a1 1 0 0 0 1.43-1.48L6.58 13H20a1 1 0 0 0 1-1 1 1 0 0 0-1-1.1z\" /></g><path id=\"back_Rectangle_37_Copy_2\" data-name=\"Rectangle 37 Copy 2\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/back.svg
// module id = JmN5
// module chunks = 6